export enum ORDER_DIRECTION_ENUM {
  CHARGE = 1,
  UNCHARGE = 2,
}

export const ORDER_DIRECTION_NAME = {
  CHARGE: 'Carga',
  UNCHARGE: 'Descarga',
}

export const ORDER_DIRECTION = {
  1: ORDER_DIRECTION_NAME.CHARGE,
  2: ORDER_DIRECTION_NAME.UNCHARGE,
}

export enum ORDER_STATE_ENUM {
  IN_PROCESS = 5,
  PROCESSED = 6,
  CANCELED = 7,
}

export const ORDER_STATE_NAME: Record<ORDER_STATE_ENUM, string> = {
  [ORDER_STATE_ENUM.IN_PROCESS]: 'Em Processamento',
  [ORDER_STATE_ENUM.PROCESSED]: 'Processado',
  [ORDER_STATE_ENUM.CANCELED]: 'Cancelado',
}

export const ORDER_STATE = {
  [ORDER_STATE_ENUM.IN_PROCESS]: ORDER_STATE_NAME[ORDER_STATE_ENUM.IN_PROCESS],
  [ORDER_STATE_ENUM.PROCESSED]: ORDER_STATE_NAME[ORDER_STATE_ENUM.PROCESSED],
  [ORDER_STATE_ENUM.CANCELED]: ORDER_STATE_NAME[ORDER_STATE_ENUM.CANCELED],
}

export enum CHARGE_STATE_ENUM {
  PENDING_APPROVAL = 1,
  APPROVED_FINANCIAL = 2,
  OPERATION_APPROVED = 3,
  DONE = 4,
  CANCELED = 5,
  RECHARGE_WITH_ERROR = 6,
  REPROCESSING = 7,
  PENDING = 8,
  SCHEDULED = 9,
}

export const CHARGE_STATE_NAME = {
  PENDING_APPROVAL: 'Pendente', // Pendente Aprovação
  APPROVED_FINANCIAL: 'Pendente', // Aprovado Finaceiro
  OPERATION_APPROVED: 'Aguardando Onboarding', // Aprovado Operacional
  DONE: 'Feito',
  CANCELED: 'Cancelado',
  RECHARGE_WITH_ERROR: 'Recarga com erro',
  REPROCESSING: 'Reprocessando',
  PENDING: 'Pendente',
  SCHEDULED: 'Carga Agendada',
}

export const CHARGE_STATE = {
  1: CHARGE_STATE_NAME.PENDING_APPROVAL,
  2: CHARGE_STATE_NAME.APPROVED_FINANCIAL,
  3: CHARGE_STATE_NAME.OPERATION_APPROVED,
  4: CHARGE_STATE_NAME.DONE,
  5: CHARGE_STATE_NAME.CANCELED,
  6: CHARGE_STATE_NAME.RECHARGE_WITH_ERROR,
  7: CHARGE_STATE_NAME.REPROCESSING,
  8: CHARGE_STATE_NAME.PENDING,
  9: CHARGE_STATE_NAME.SCHEDULED,
}

// Constantes específicas para descarga (UNCHARGE)
export const UNCHARGE_STATE_NAME = {
  PENDING_APPROVAL: 'Pendente', // Pendente Aprovação
  APPROVED_FINANCIAL: 'Pendente', // Aprovado Finaceiro
  OPERATION_APPROVED: 'Pendente', // Aprovado Operacional - alterado para "Pendente" na descarga
  DONE: 'Feito',
  CANCELED: 'Cancelado',
  RECHARGE_WITH_ERROR: 'Descarga com erro',
  REPROCESSING: 'Reprocessando',
  PENDING: 'Pendente',
  SCHEDULED: 'Carga Agendada',
}

export const UNCHARGE_STATE = {
  1: UNCHARGE_STATE_NAME.PENDING_APPROVAL,
  2: UNCHARGE_STATE_NAME.APPROVED_FINANCIAL,
  3: UNCHARGE_STATE_NAME.OPERATION_APPROVED,
  4: UNCHARGE_STATE_NAME.DONE,
  5: UNCHARGE_STATE_NAME.CANCELED,
  6: UNCHARGE_STATE_NAME.RECHARGE_WITH_ERROR,
  7: UNCHARGE_STATE_NAME.REPROCESSING,
  8: UNCHARGE_STATE_NAME.PENDING,
  9: UNCHARGE_STATE_NAME.SCHEDULED,
}

export enum METHOD_2FA_ENUM {
  EMAIL = 1,
  PHONE = 2,
}

export enum TransactionTypeEnum {
  ALL = 0,
  ORDERS = 1,
  DEPOSIT = 2,
  CANCELLATION = 3,
}

export enum GET_USER_VARIANT {
  USER_DETAILS_LOGGED = 'userDetailsLogged',
  USER_DETAILS = 'userDetails',
}

export const PATHS_REPORT = {
  TRANSFERS: 'transfers',
  PAYMENTS: 'payments',
  DENIED_TRANSACTIONS: 'denied_transactions',
  CELL_PHONE_RECHARGES: 'cell_phone_recharges',
  STATEMENT: 'statement',
}

export enum BATCH_CARDS_ENUM {
  CREATING = 1,
  READY = 2,
  PROCESSING = 3,
  DONE = 4,
}

export const BATCH_CARDS_NAME: Record<BATCH_CARDS_ENUM, string> = {
  [BATCH_CARDS_ENUM.CREATING]: 'Criando',
  [BATCH_CARDS_ENUM.READY]: 'Pronto',
  [BATCH_CARDS_ENUM.PROCESSING]: 'Em processamento',
  [BATCH_CARDS_ENUM.DONE]: 'Processado',
}

export const BATCH_CARDS = {
  [BATCH_CARDS_ENUM.CREATING]: BATCH_CARDS_NAME[BATCH_CARDS_ENUM.CREATING],
  [BATCH_CARDS_ENUM.READY]: BATCH_CARDS_NAME[BATCH_CARDS_ENUM.READY],
  [BATCH_CARDS_ENUM.PROCESSING]: BATCH_CARDS_NAME[BATCH_CARDS_ENUM.PROCESSING],
  [BATCH_CARDS_ENUM.DONE]: BATCH_CARDS_NAME[BATCH_CARDS_ENUM.DONE],
}

export enum ACTION_BATCH_CARDS_ENUM {
  NO_ACTION = 1,
  PENDING_ACTION = 2,
  ACTION_DONE = 3,
  ERROR = 4,
}

export const ACTION_BATCH_CARDS_NAME: Record<ACTION_BATCH_CARDS_ENUM, string> =
  {
    [ACTION_BATCH_CARDS_ENUM.NO_ACTION]: '-', // Sem ação
    [ACTION_BATCH_CARDS_ENUM.PENDING_ACTION]: 'Processando',
    [ACTION_BATCH_CARDS_ENUM.ACTION_DONE]: 'Processado',
    [ACTION_BATCH_CARDS_ENUM.ERROR]: 'Erro',
  }

export const ACTION_BATCH_CARDS = {
  [ACTION_BATCH_CARDS_ENUM.NO_ACTION]:
    ACTION_BATCH_CARDS_NAME[ACTION_BATCH_CARDS_ENUM.NO_ACTION],
  [ACTION_BATCH_CARDS_ENUM.PENDING_ACTION]:
    ACTION_BATCH_CARDS_NAME[ACTION_BATCH_CARDS_ENUM.PENDING_ACTION],
  [ACTION_BATCH_CARDS_ENUM.ACTION_DONE]:
    ACTION_BATCH_CARDS_NAME[ACTION_BATCH_CARDS_ENUM.ACTION_DONE],
  [ACTION_BATCH_CARDS_ENUM.ERROR]:
    ACTION_BATCH_CARDS_NAME[ACTION_BATCH_CARDS_ENUM.ERROR],
}

export enum SEND_ACTIONS_ENUM {
  LOCK = 1,
  UNLOCK = 2,
  CANCEL = 3,
}
